import React from "react";
import Index from "../Index";

const ConfirmModal = (props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
  };
  return (
    <Index.Modal
      open={props.statusModalOpen}
      onClose={props.handleStatusModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modal-delete modal"
    >
      <Index.Box sx={style} className="delete-modal-inner-main modal-inner">
        <Index.Box className="modal-circle-main" onClick={props.handleStatusModalClose}>
          <img
            src={Index.Svg.close}
            className="user-circle-img"
            alt="icon"
          />
        </Index.Box>
        <Index.Box className="modal-contained-wrap">
          <Index.Box >
            <Index.Typography
              className="delete-modal-para common-para"
              component="p"
              variant="p"
            >
              {props?.message
                ? props?.message
                : "Are you sure? Do you really want to update this records?"}
            </Index.Typography>
          </Index.Box>
          <Index.Box className="delete-modal-btn-flex">
            <Index.Button
              className="modal-cancel-btn modal-btn"
              onClick={props.handleStatusModalClose}
            >
              No
            </Index.Button>
            <Index.Button
              className="modal-delete-btn modal-btn"
              onClick={props.handleUpdateRecord}
            >
              Yes
            </Index.Button>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </Index.Modal>
  );
};

export default ConfirmModal;
